import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environmentConfig } from '../../environment';

export type TemplateTypeDto = {
    template_id: number;
    template_name: string;
    import_table: string;
    description?: string;
    created_at?: string;
    created_by?: string;
};

export type BatchRecordDto = {
  batch_id: number;
  batch_start: string;
  batch_end?: string;
  owner: string;
  rows?: number;
};

export type PreviewResponse = {
    uploadId: string;
    columns: { name: string; sqlType: string }[];
    rowCount: number;
    safeSuggestedTableName: string;
};

@Injectable({ providedIn: 'root' })
export class ExcelImportService {
    private apiUrl = environmentConfig.apiBaseUrl;

    constructor(private http: HttpClient) { }

    private authHeaders(token: string) {
        return new HttpHeaders(token ? { Authorization: `Bearer ${token}` } : {});
    }

    getTemplateTypes(token: string): Observable<TemplateTypeDto[]> {
        const url = `${this.apiUrl}/api/dataimport/gettemplatetypes`;
        return this.http.get<TemplateTypeDto[]>(url, { headers: this.authHeaders(token) });
    }

    uploadPreview(
        file: File,
        templateName: string,
        importTable: string,
        token: string
    ): Observable<HttpEvent<PreviewResponse>> {
        const url = `${this.apiUrl}/api/imports/excel/preview`;
        const form = new FormData();
        form.append('file', file, file.name);
        form.append('templateName', templateName);
        form.append('importTable', importTable);

        return this.http.post<PreviewResponse>(url, form, {
            headers: this.authHeaders(token),
            reportProgress: true,
            observe: 'events'
        });
    }

    commitExcel(
        file: File,
        tableName: string,
        token: string,
        uploadedBy?: string
    ) {
        const url = `${this.apiUrl}/api/imports/excel/commit`;
        const form = new FormData();
        form.append('file', file, file.name);
        form.append('tableName', tableName);
        if (uploadedBy) form.append('uploadedBy', uploadedBy);

        return this.http.post<{ table: string; rows: number; batchId: number }>(url, form, {
            headers: this.authHeaders(token),
            observe: 'events',
            reportProgress: true,
        });
    }

  getBatchData(token: string, filetype: string): Promise<any> {
    const url = `${this.apiUrl}/api/dataimport/getbatchdata?ftype=${filetype}`;
    return this.http.get<BatchRecordDto[]>(url, { headers: this.authHeaders(token) }).toPromise();
  }

  getBatchDetail(token: string, batchId: number): Promise<any> {
    const url = `${this.apiUrl}/api/dataimport/getbatchdetail?batchId=${batchId}`;
    return this.http.get<any>(url, { headers: this.authHeaders(token) }).toPromise();
  }
}
